import { render, staticRenderFns } from "./QuizResultSelectorHeader.vue?vue&type=template&id=27d2a562&"
import script from "./QuizResultSelectorHeader.vue?vue&type=script&lang=js&"
export * from "./QuizResultSelectorHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports